import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Spinner } from 'reactstrap';
import { colors } from 'shared/defaultTheme';

import { SpinnerWrapper } from './styles';

const MainSpinner = ({ className }) => {
  const theme = useSelector((state) => state.theme);
  const { mainColor } = theme;

  return (
    <SpinnerWrapper className={className}>
      <Spinner color={mainColor ?? colors.blueLefebvre} />
    </SpinnerWrapper>
  );
};

MainSpinner.defaultProps = {
  className: '',
};

MainSpinner.propTypes = {
  className: PropTypes.string,
};

export default MainSpinner;
